import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link từ react-router-dom
import axios from 'axios';
import '../style/TopStories.css';

const TopStories = () => {
  const [topStories, setTopStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hoveredStory, setHoveredStory] = useState(null); // State để lưu truyện đang được hover

  // Hàm gọi API để lấy danh sách top truyện
  const fetchTopStories = async () => {
    try {
      const response = await axios.get('https://otruyenapi.com/v1/api/home');
      const filteredStories = response.data.data.items
        .filter(story => story.chaptersLatest && story.chaptersLatest.length > 0)
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
        .slice(0, 7); // Giới hạn top 7 truyện
      
      setTopStories(filteredStories);
    } catch (err) {
      setError('Có lỗi xảy ra khi tải danh sách truyện');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopStories();
  }, []);

  if (loading) {
    return <p>Đang tải...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div className="top-stories-container">
      <h2 className="title">TOP TRUYỆN</h2>
      <hr style={{ margin: '20px 0', border: '1px solid #ccc' }} />
      <div className="top-list">
        {topStories.map((story, index) => (
          <div
            className={`top-item ${hoveredStory === story._id ? 'hovered' : ''}`} // Thêm class 'hovered' khi item đang được hover
            key={story._id}
            onMouseEnter={() => setHoveredStory(story._id)} // Khi di chuột vào
            onMouseLeave={() => setHoveredStory(null)} // Khi di chuột ra
          >
            {/* Bọc ảnh bằng thẻ Link */}
            <Link to={`/comics/${story.slug}`}>
              <img
                src={`https://img.otruyenapi.com/uploads/comics/${story.thumb_url}`}
                alt={story.name}
                className="top-story-thumb"
              />
            </Link>
            <div className="top-story-details">
              <p className="top-story-name">{story.name}</p>
              {story.chaptersLatest && story.chaptersLatest.length > 0 && (
                <p className="top-story-chapter">
                  Chương mới nhất: {story.chaptersLatest[0].chapter_name}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopStories;
